import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from 'recoil';
import { isIbarakiAgFlag } from 'atoms/projectData';


// 解析点をフィルタリングを行う処理
export const useAnalysisPointFiltering = (analysisVer) => {
  const { t } = useTranslation();

  //Recoilから取得
  const ibarakiAgFlag = useRecoilValue(isIbarakiAgFlag);  

   // モーダルの開閉状態を制御
  const [analysisFilteringModalIsOpen, setAnalysisFilteringModalIsOpen] = useState(false);
  const handleChangeAnalysisFilteringModalOpen = useCallback(() => setAnalysisFilteringModalIsOpen(true),[]); // モーダル開く処理
  const handleChangeAnalysisFilteringModalClose = useCallback(() => setAnalysisFilteringModalIsOpen(false),[]); // モーダル閉じる処理

  // フィルタリングの初期値を定義
  const active = ibarakiAgFlag;
  const subject = ibarakiAgFlag ? "c" : "";
  const conditions = ibarakiAgFlag ? ">=" : "";
  const value = ibarakiAgFlag ? "0.98" : "";

  // フィルタリング関連
  const [analysisFilteringArrays, setAnalysisFilteringArrays] = useState([{ active: active, subject: subject, conditions: conditions, value: value}]); // 選択した解析点をフィルタリングする対象をstateに保存する処理
  const [addFilteringFlag, setAddFilteringFlag] = useState(false); // フィルタリング項目追加ボタンの非活性フラグ
  const [analysisFilteringFlag, setAnalysisFilteringFlag] = useState(false); // フィルタリングの実行フラグ
  const [analysisFilteringResetFlag, setAnalysisFilteringResetFlag] = useState(false); // フィルタリングのリセットフラグ
  const [analysisFilteringIsActive, setAnalysisFilteringIsActive] = useState(false); // フィルタリング中かどうか管理するフラグ
  const [analysisFilterCalcRate, setAlysisFilterCalcRate] = useState({aoiName: [], allPointNum: 0, FilterPointNum: 0}); // aoiName: 解析点表示中のAOIのID, allPointNum: 表示中の解析点の数, FilterPointNum: フィルタリング後に表示している解析の数
  const [isAnalysisFilterCalc, setIsAnalysisFilterCalc] = useState(false);

  // 解析点をフィルタリングする対象の配列を定義
  let filteringSubjects = [];
  if(analysisVer >= 3.0){
    filteringSubjects = [
      {key: t("map.rateOfVariation"), value: "v"},
      {key: t("map.elevation"), value: "h"},
      {key: t("map.directionGradient"), value: "d"},
      {key: t("map.angleSlope"), value: "g"},
      {key: t("map.reliability"), value: "c"},
    ]
  }else if(analysisVer >= 2.0){
    filteringSubjects = [
      {key: t("map.rateOfVariation"), value: "v"},
      {key: t("map.elevation"), value: "h"},
      {key: t("map.directionGradient"), value: "d"},
      {key: t("map.angleSlope"), value: "g"},
    ]
  }else if(analysisVer >= 1.0){
    filteringSubjects = [
      {key: t("map.rateOfVariation"), value: "v"},
    ]
  }

  // 解析点のフィルタリング条件を配列を定義
  const filtergingConditions = [
    {operator: ">=", value: t("map.nextHiger")},
    {operator: "<=", value: t("map.following")},
    {operator: ">", value: t("map.nextLarger")},
    {operator: "<", value: t("map.lessTheNext")}
  ]

  // フィルタリング項目の各入力項目を変更した際の処理
  const handleChangeFilteringTextSelectInput = useCallback((e, target, index) => {
    setAnalysisFilteringArrays(prevState => 
      prevState.map((item, i) => {
        if (i === index) {
          // 指定された項目を更新
          const updatedItem = { ...item, [target]: e };
          // subject, conditions, valueがすべて空でないかチェック
          const allFieldsFilled = updatedItem.subject !== "" && updatedItem.conditions !== "" && updatedItem.value !== "";
          // targetが"active"の場合、activeの値を更新
          if (target === "active") {
            return { ...updatedItem, active: allFieldsFilled ? e : item.active };
          }
          // それ以外の場合、allFieldsFilledがtrueならactiveをtrueに設定
          return { ...updatedItem, active: allFieldsFilled };
        }
        return item; // それ以外のオブジェクトはそのまま
      })
    );

    // フィルタリングモーダル内の値を更新した際は即時フィルタリングを実行する
    if(target === "value" || target === "active"){
      setAnalysisFilteringFlag(true); //　フィルタリングを実行
      setAnalysisFilteringIsActive(true); // フィルタリング実行中フラグをON
    }
  }, []);

  // フィルタリングを実行する処理
  const handleClickAnalysisPonitFilteringFlag = useCallback(() => {
    setAnalysisFilteringFlag(true); //　フィルタリングを実行
    setAnalysisFilteringIsActive(true); // フィルタリング実行中フラグをON
  },[])
  // フィルタリングをリセットする処理
  const handleClickAnalysisPonitFilteringResetFlag = useCallback(() => {
    setAnalysisFilteringArrays(prevState => prevState.slice(0, 1)); // 先頭の配列以外を削除する
    setAnalysisFilteringArrays(prevState => prevState.map(item => ({...item, active: false, subject: "", conditions: "", value: ""}))); // 先頭の配列の入力項目をリセットする
    setAnalysisFilteringResetFlag(true); // フィルタリングのリセットフラグ
    setAnalysisFilteringIsActive(false); // フィルタリング実行中フラグをOFF
    setAlysisFilterCalcRate((prevState) => {
      return {
        ...prevState,
        aoiName: [],
        FilterPointNum: analysisFilterCalcRate.allPointNum,
      };
    });
  },[analysisFilterCalcRate]);

  // フィルタリング項目を追加する処理
  const handleClickAddfilteringRecord = useCallback(() => {
    // フィルタリング項目数に達した場合は追加ボタンを非活性にする
    if(analysisFilteringArrays.length >= filteringSubjects.length * 2) {
      setAddFilteringFlag(true);
      return;
    }
    // 項目(レコード)を追加
    setAnalysisFilteringArrays(prevState => [
      ...prevState, 
      { active: false, subject: "", conditions: "", value: "" }
    ]);
  },[analysisFilteringArrays])

  // フィルタリング項目を削除する処理
  const handleClickRemovefilteringRecord = useCallback((indexToRemove) => {
    if(analysisFilteringArrays.length === 1) return; // 最後の1つは削除せずに処理を停止

    // 項目(レコード)を削除
    setAnalysisFilteringArrays(prevState =>
      prevState.filter((_, index) => index !== indexToRemove)
    );

    // 再度フィルタリングを実行
    setAnalysisFilteringFlag(true);
  },[analysisFilteringArrays])

  // マップ画面に表示中の解析点の数値を更新する処理
  const handleClickAnalysisPointShowNum = useCallback((aoiName, pointNum, flag, nowRenderPoint) => {

    // 解析点を追加したとき
    if (flag){
      // 解析点表示中のIDの格納と表示中の解析点の数を足す処理
      if (!analysisFilterCalcRate.aoiName.includes(aoiName)) { // 既に解析点を表示しているAOIはスキップ
        setAlysisFilterCalcRate((prevState) => {
          if (!prevState.aoiName.includes(aoiName)) {
            return {
              ...prevState,
              aoiName: [...prevState.aoiName, aoiName],
              FilterPointNum: Number(prevState.allPointNum) + Number(pointNum),
              allPointNum: Number(prevState.allPointNum) + Number(pointNum)
            };
          }
          return prevState; // 変更がない場合はそのまま返す
        });
      }
    }

    // 解析点を削除したとき
    if (!flag){         
      // 解析点表示中のIDの格納と表示中の解析点の数を減算する処理
      if (analysisFilterCalcRate.aoiName.includes(aoiName)) { // 既に解析点を表示していないAOIの場合はスキップ
        setAlysisFilterCalcRate((prevState) => {
          return {
            ...prevState,
            aoiName: prevState.aoiName.filter((item) => item !== aoiName), // 指定要素を削除
            FilterPointNum: Number(prevState.FilterPointNum) - Number(nowRenderPoint),
            allPointNum: Number(prevState.allPointNum) - Number(pointNum)
          };
        });
      }
    }

  },[analysisFilterCalcRate])

  // 解析点のフィルタリングを行った結果、表示中の解析点の数を格納
  const handleChangePointCalcRate = useCallback((showPointNum) => {
    setAlysisFilterCalcRate((prevState) => {
      if (!prevState.aoiName.includes(showPointNum)) {
        return {
          ...prevState,
          FilterPointNum: showPointNum, // フィルタリングしたあとに表示中の解析点の数
        };
      }
      return prevState; // 変更がない場合はそのまま返す
    });
  },[])

  // 解析点の総数計算を行うかどうかのフラグを更新
  const handleClickPointCalcFlag = useCallback(() => setIsAnalysisFilterCalc(prevState => !prevState),[])

  // 茨城県の場合はフィルタリングを即時実行する
  useEffect(() => {
    if(ibarakiAgFlag) setAnalysisFilteringIsActive(true); // フィルタリング実行中フラグをON
  },[])

  return {
    analysisFilteringModalIsOpen,
    handleChangeAnalysisFilteringModalOpen,
    handleChangeAnalysisFilteringModalClose,
    filteringSubjects,
    filtergingConditions,
    analysisFilteringArrays,
    handleClickAddfilteringRecord,
    handleClickRemovefilteringRecord,
    addFilteringFlag,
    handleChangeFilteringTextSelectInput,
    handleClickAnalysisPonitFilteringFlag,
    handleClickAnalysisPonitFilteringResetFlag,
    handleClickAnalysisPointShowNum,
    analysisFilteringFlag,
    analysisFilteringResetFlag,
    setAnalysisFilteringFlag,
    setAnalysisFilteringResetFlag,
    analysisFilteringIsActive,
    setAnalysisFilteringIsActive,
    handleChangePointCalcRate,
    analysisFilterCalcRate,
    isAnalysisFilterCalc,
    handleClickPointCalcFlag
  };
};